import React, { Component } from 'react';
import format from 'date-fns/format';

import './CheckoutEstimate.scss';

import { DELIVERY_DATE_FORMAT, getEstimatedDeliveryDate } from 'helpers';
import { formatCurrency } from 'formatters';

interface OwnProps {
    leadTime?: number;
    deliveryCost?: number;
    deliverNotBefore?: Date | null;
    hasQuickstockItem: boolean;
}

class CheckoutEstimate extends Component<OwnProps> {
    render(): JSX.Element {
        const { leadTime, deliveryCost, deliverNotBefore, hasQuickstockItem } = this.props;

        return (
            <div className='checkout-estimate'>
                <div className='checkout-estimate__header'>
                    <div className='checkout-estimate__header__text'>
                        <i className='sa sa-delivery-fast truck'></i>
                        Estimated:
                    </div>
                    <div className='checkout-estimate__header__count'>{leadTime ? getEstimatedDeliveryDate(leadTime, hasQuickstockItem) : getEstimatedDeliveryDate(NaN, hasQuickstockItem)}</div>
                </div>

                <div className='checkout-estimate__not-before'>
                    <div className='checkout-estimate__not-before__text'>Not before:</div>
                    <div className='checkout-estimate__not-before__date'>
                        {deliverNotBefore ? format((deliverNotBefore), DELIVERY_DATE_FORMAT) : ''}
                    </div>
                </div>

                <div className='checkout-estimate__delivery-cost'>
                    <div className='checkout-estimate__delivery-cost__text'>Delivery Cost:</div>
                    <div className='checkout-estimate__delivery-cost__cost'>{deliveryCost !== undefined && deliveryCost !== null ? formatCurrency(deliveryCost) : ''}</div>
                </div>
            </div>
        );
    }
}

export default CheckoutEstimate;